var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtvXboxStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7466_3378)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "url(#paint0_radial_7466_3378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7151 14.019C2.70419 14.011 2.69301 14.0009 2.68182 13.9886C2.47474 13.8002 2.13744 13.5031 1.78496 13.0539C1.48055 12.3937 1.6531 11.2846 2.40224 9.71857C3.45922 7.50908 5.15038 5.26577 5.84375 4.47C5.64649 4.24989 5.03541 3.64716 4.16951 2.99701C3.30363 2.34686 2.67282 2.28026 2.45297 2.31977C2.65592 2.09967 3.12944 1.68486 3.52687 1.4055C4.75803 0.795989 7.03323 1.82596 8.00849 2.41289V6.45091C5.52243 8.36411 3.22246 11.3186 2.75738 12.4698C2.40242 13.3486 2.54275 13.8359 2.68182 13.9886C2.69332 13.9991 2.70443 14.0092 2.7151 14.019Z",
    fill: "url(#paint1_linear_7466_3378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7151 14.0189C2.70419 14.0109 2.69301 14.0008 2.68181 13.9885C2.47473 13.8001 2.13744 13.503 1.78496 13.0538C1.48055 12.3936 1.6531 11.2844 2.40224 9.71847C3.62937 7.15332 5.84375 4.46988 5.84375 4.46988C5.84375 4.46988 6.23918 5.45172 7.13649 7.15332C4.82541 9.20195 3.22245 11.3184 2.75738 12.4697C2.40242 13.3485 2.54274 13.8358 2.68181 13.9885C2.69332 13.999 2.70442 14.0091 2.7151 14.0189Z",
    fill: "url(#paint2_linear_7466_3378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3017 14.019C13.3126 14.011 13.3238 14.0009 13.335 13.9886C13.5421 13.8002 13.8793 13.5031 14.2318 13.0539C14.5362 12.3937 14.3637 11.2846 13.6145 9.71857C12.5576 7.50908 10.8664 5.26577 10.173 4.47C10.3703 4.24989 10.9814 3.64716 11.8473 2.99701C12.7132 2.34686 13.344 2.28026 13.5638 2.31977C13.3609 2.09967 12.8873 1.68486 12.4899 1.4055C11.2588 0.795989 8.98356 1.82596 8.0083 2.41289V6.45091C10.4944 8.36411 12.7944 11.3186 13.2594 12.4698C13.6144 13.3486 13.4741 13.8359 13.335 13.9886C13.3234 13.9991 13.3124 14.0092 13.3017 14.019Z",
    fill: "url(#paint3_linear_7466_3378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3017 14.0189C13.3127 14.0109 13.3239 14.0008 13.3351 13.9885C13.5421 13.8001 13.8794 13.503 14.2319 13.0538C14.5363 12.3936 14.3637 11.2844 13.6146 9.71847C12.3875 7.15332 10.1731 4.46988 10.1731 4.46988C10.1731 4.46988 9.77769 5.45172 8.88037 7.15332C11.1915 9.20195 12.7944 11.3184 13.2595 12.4697C13.6144 13.3485 13.4741 13.8358 13.3351 13.9885C13.3236 13.999 13.3124 14.0091 13.3017 14.0189Z",
    fill: "url(#paint4_linear_7466_3378)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7466_3378",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8 7.14286) rotate(90.0548) scale(8.85714)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499976,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828794,
    stopColor: "#C0BEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#879288"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7466_3378",
    x1: 6.28146,
    y1: 1.55765,
    x2: 6.41695,
    y2: 6.16297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7466_3378",
    x1: 4.65609,
    y1: 6.09527,
    x2: 6.21375,
    y2: 8.22858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48BF21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7466_3378",
    x1: 9.73533,
    y1: 1.55765,
    x2: 9.59984,
    y2: 6.16297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7466_3378",
    x1: 11.3608,
    y1: 6.09527,
    x2: 9.80311,
    y2: 8.22858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48BF21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7466_3378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvXboxStore);
export default __webpack_public_path__ + "static/media/ctv_xbox_store.3479f5a7aea15b3692a417c20ccfb3aa.svg";
export { ForwardRef as ReactComponent };